import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";

const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.46a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.39Z" />
  </svg>
);

export const TikTokSection = () => {
  // Charge / recharge le script TikTok pour parser le <blockquote class="tiktok-embed">
  useEffect(() => {
    const existing = document.getElementById("tiktok-embed-script");
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.id = "tiktok-embed-script";
    script.src = "https://www.tiktok.com/embed.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      const s = document.getElementById("tiktok-embed-script");
      if (s) s.remove();
    };
  }, []);

  return (
    <section className="section-padding bg-gradient-to-b from-white to-slate-50" data-testid="home-tiktok-section">
      <div className="container-custom max-w-5xl">
        <div className="text-center mb-10">
          <Badge className="bg-black text-white px-4 py-2 mb-4 hover:bg-black inline-flex items-center gap-2">
            <TikTokIcon className="w-4 h-4" />
            TikTok @mediastore79
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Mediastore en vidéo</h2>
          <p className="text-lg text-slate-600">
            Découvrez nos réparations, astuces et coulisses de l&apos;atelier Niortais sur TikTok.
          </p>
        </div>

        <div className="flex justify-center">
          <blockquote
            className="tiktok-embed"
            cite="https://www.tiktok.com/@mediastore79"
            data-unique-id="mediastore79"
            data-embed-type="creator"
            style={{ maxWidth: 780, minWidth: 288 }}
          >
            <section>
              <a target="_blank" rel="noopener noreferrer" href="https://www.tiktok.com/@mediastore79?refer=creator_embed">
                @mediastore79
              </a>
            </section>
          </blockquote>
        </div>

        <div className="text-center mt-8">
          <a href="https://www.tiktok.com/@mediastore79" target="_blank" rel="noopener noreferrer" data-testid="tiktok-cta-btn">
            <Button size="lg" className="bg-black hover:bg-slate-900 text-white gap-2">
              <TikTokIcon className="w-5 h-5" />
              Suivez-nous sur TikTok
              <ArrowRight className="h-4 w-4" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
